<script setup lang="ts">
import { computed } from "vue";
import { useBrandStore } from "@/stores/brand-store";
import { useRouter } from "vue-router";

const router = useRouter();

const brands = computed(() => useBrandStore().accessibleBrands);

const selectedBrand = computed({
  get() {
    return useBrandStore().selectedBrand;
  },
  set(brand: string) {
    router.push({ name: "brand", params: { brand } });
  },
});
</script>
<template>
  <div tabindex="0" class="tw-px-2">
    Brand:
    <select
      v-if="brands.length > 1"
      v-model="selectedBrand"
      class="tw-min-w-0 tw-truncate tw-rounded-md tw-border tw-border-black/70 tw-p-1 tw-text-black"
      aria-label="Select brand"
    >
      <option v-for="b in brands" :key="b" :value="b">{{ b.toUpperCase() }}</option>
    </select>
    <template v-else>{{ selectedBrand }}</template>
  </div>
</template>
